var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "popup_wrap", staticStyle: { width: "1750px" } },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.layerClose()
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(_vm._s(_vm.$t("cp.CTRL020P160.001"))),
        ]),
        _c("div", { staticClass: "content_box mt10" }, [
          _c("div", { staticClass: "cp-popinfo" }, [
            _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.$t("cp.CTRL020P160.002")))]),
              _c("span", [_vm._v(_vm._s(_vm.parentInfo.sfOpt.scenarioNm))]),
            ]),
            _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.$t("cp.CTRL020P160.003")))]),
              _c("span", [_vm._v(_vm._s(_vm.parentInfo.sfOpt.effectTo))]),
            ]),
            _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.$t("cp.CTRL020P160.004")))]),
              _c("span", [_vm._v(_vm._s(_vm.$t("cp.CTRL020P160.005")))]),
            ]),
            _c("div"),
          ]),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "text_center mt10" }, [
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.asyncAlert(_vm.$t("cp.CTRL020P160.006"))
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cp.COMMON.011")))]
          ),
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.layerClose()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cp.COMMON.007")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content_box cp-parentnode" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "482px" },
        attrs: { id: "realgrid" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }